export default function state() {
	return {
		engageProperties: {
			expiry: null,
			url: null,
		},
		loading: false,
		error: false,
	}
}
